/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import Paper from 'apollo-react/components/Paper';
import ChevronRight from 'apollo-react-icons/ChevronRight';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useFormSelector } from '../../../custom-hooks';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import { getUITA } from '../../../utils/commonUtils';
import { setSelectedControl } from '../../actions/editor.actions';
import { SS_CONTROL_TYPE } from '../../constants/form-manager.constants';
import { getClosestParentIdByType, getSelectedControlId } from '../../selectors/editor.selectors';

const useStyles = makeStyles({
  container: {
    padding: 7,
  },
  expandContainer: {
    display: 'flex',
    '&:hover': {
      color: '#0557d5',
    },
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  subFormHeader: {
    paddingLeft: '3px',
  },
  accordionText: {
    display: 'flex',
  },
});

const SSEditorSubForm = ({ controlId, children, formName, childrenNodes }) => {
  const [isOpen, setIsOpen] = useState(false);
  const classes = useStyles();
  const translateString = useTranslation();
  const dispatch = useDispatch();
  const selectedControlId = useFormSelector(getSelectedControlId);
  const subFormId = useFormSelector(getClosestParentIdByType, {
    id: selectedControlId,
    type: SS_CONTROL_TYPE.SUB_FORM,
  });
  const childFormId = childrenNodes[0];

  useEffect(() => {
    if (controlId === subFormId) {
      setIsOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedControlId]);

  const expandSubFormComponent = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const formPropertiesButtonClick = (e) => {
    e.stopPropagation();
    if (childFormId) {
      if (!isOpen) {
        setIsOpen(!isOpen);
      }
      dispatch(setSelectedControl(childFormId, true));
    }
  };

  return (
    <Paper elevation={1} className={classes.container}>
      <div
        onClick={expandSubFormComponent}
        className={classes.expandContainer}
        ui-ta={getUITA('FormCtrl', 'SSEditorSubForm', formName)}
      >
        <div className={classes.accordionText}>
          <ChevronRight
            fontSize="small"
            style={{ transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)' }}
          />
          <p className={classes.subFormHeader}>{formName}</p>
        </div>
        <Button
          color="secondary"
          variant="secondary"
          size="small"
          onClick={formPropertiesButtonClick}
        >
          {translateString('Form Properties')}
        </Button>
      </div>
      {isOpen && children}
    </Paper>
  );
};

export default SSEditorSubForm;
